import * as MutationsType from "./mutationsType";
import requestAxios from "@/helpers/request_axios";

export default {
  async getAllAutomations({ commit }) {
    let response = await requestAxios({
      url: "/awy/api/v1/automations",
      method: "GET",
    });

    commit(MutationsType.SET_AUTOMATIONS, response.data.data);
  },
  async getAutomationById({ commit, state }, { topic, id }) {
    let automation = (state.automations || []).find((automation) => automation.id === id);
    if (!automation) {
      let response = await requestAxios({
        url: `/awy/api/v1/automations/${topic}/${id}`,
        method: "GET",
      });

      automation = response.data.data;
    }

    commit(MutationsType.SET_AUTOMATION, automation);
  },
  async getAutomationByTopicAndType({ commit }, { topic, type }) {
    let response = await requestAxios({
      url: `/awy/api/v1/automations/${topic}`,
      method: "GET",
      params: { type },
    });

    commit(MutationsType.SET_AUTOMATIONS, response.data.data);
    commit(MutationsType.SET_AUTOMATION, response.data.data[0]);

    return response.data.data[0];
  },
  async saveAutomation({ commit, state }, { data }) {
    let response = await requestAxios({
      // url: `/awy/api/v1/automations/${topic}`,
      url: "/awy/api/v1/automations",
      method: "POST",
      data: data,
    });

    // commit(MutationsType.SET_AUTOMATION, response.data.data);

    if (!state.automations) commit(MutationsType.SET_AUTOMATIONS, []);

    commit(MutationsType.ADD_AUTOMATION, response.data.data);

    return response.data;
  },
  async updateAutomation({ commit }, { id, data }) {
    let response = await requestAxios({
      url: `/awy/api/v1/automations/${id}`,
      method: "PATCH",
      data: data,
    });

    commit(MutationsType.UPDATE_AUTOMATION, response.data.data);

    return response.data;
  },
  async deleteAutomation({ commit, state }, { topic, id }) {
    let response = await requestAxios({
      url: `/awy/api/v1/automations/${topic}/${id}`,
      method: "DELETE",
    });

    if (state.automation?.id === id) commit(MutationsType.SET_AUTOMATION, null);

    commit(MutationsType.DELETE_AUTOMATION, { id });

    return response.data;
  },
  resetAutomation({ commit }) {
    commit(MutationsType.SET_AUTOMATION, null);
  },
  resetModuleAutomation({ commit }) {
    commit(MutationsType.SET_AUTOMATION, null);
    commit(MutationsType.SET_AUTOMATIONS, null);
  },
};
